const docSubSearchResultTableStyle = theme => ({
	root: {
		// width: '100%',
	},

	paper: {
		// width: '100%',
		marginBottom: theme.spacing(2),
	},

	table: {
		minWidth: 300,
	},

	container: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 450),
	},

	toolbar: {
		display: 'flex',
		alignItems: 'center',
	},

	// tablePagination: {
	// 	padding: 10
	// },


	tablePagination: {
		display: "flex",
		justifyContent: "center",

		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
	},




	linkContent: {
		// textDecorationLine: "underline",
		color: "primary",
		cursor: "pointer"
	}
})

export default docSubSearchResultTableStyle